import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { useTexture } from '@react-three/drei';

const RunnerCharacter = ({ isBouncing }) => {
    const spriteRef = useRef();

    // Load character texture
    const texture = useTexture(process.env.PUBLIC_URL + '/assets/gameplay/man_walking.png');

    useFrame((state) => {
        if (spriteRef.current) {
            // Man is steady now - no bobbing as requested
            spriteRef.current.position.y = -2.8;
            spriteRef.current.rotation.z = 0;
            spriteRef.current.position.z = 0;
        }
    });

    return (
        <sprite
            ref={spriteRef}
            position={[0, -2.8, 0]}
            scale={[6.8, 6.0, 1]}
            renderOrder={999}
        >
            <spriteMaterial map={texture} transparent={true} depthTest={false} />
        </sprite>
    );
};

export default RunnerCharacter;
